import React, { useState } from 'react';
import { Card, CardContent, Typography, TextField, Button, Box, Container, Alert, CircularProgress } from '@mui/material'; // Added CircularProgress
import { Link } from 'react-router-dom';
import api from '../../services/api';

const ForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false); // New loading state

    const handleSubmit = async (event) => {
        event.preventDefault();
        setMessage('');
        setError('');
        setLoading(true); // Start loading
        try {
            const response = await api.post('/auth/forgot-password', { email: email.toLowerCase() });
            setMessage(response.data.message);
        } catch (err) {
            console.error(err);
            setError('An unexpected error occurred. Please try again.');
        } finally {
            setLoading(false); // Stop loading
        }
    };

    return (
        <Box sx={{ minHeight: 'calc(100vh - 80px)', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(45deg, #6a11cb 30%, #2575fc 90%)', padding: 4 }}>
            <Container maxWidth="xs">
                <Card>
                    <CardContent sx={{ padding: 4 }}>
                        <Typography variant="h5" gutterBottom align="center" fontWeight="bold">Reset Your Password</Typography>
                        <Typography variant="body2" color="textSecondary" align="center" mb={2}>Enter your email address and we will send you a link to reset your password.</Typography>
                        {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
                        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                        {!message && (
                            <Box component="form" onSubmit={handleSubmit} noValidate>
                                <TextField 
                                    margin="normal" 
                                    required 
                                    fullWidth 
                                    id="email" 
                                    label="Email Address" 
                                    name="email" 
                                    autoComplete="email" 
                                    autoFocus 
                                    value={email} 
                                    onChange={(e) => setEmail(e.target.value)}
                                    disabled={loading} // Disabled when loading
                                />
                                <Button 
                                    type="submit" 
                                    fullWidth 
                                    variant="contained" 
                                    color="primary" 
                                    sx={{ mt: 3, mb: 2, py: 1.5 }}
                                    disabled={loading || !email} // Disabled when loading or email is empty
                                >
                                    {loading ? (
                                        <CircularProgress size={24} color="inherit" />
                                    ) : (
                                        'Send Reset Link'
                                    )}
                                </Button>
                            </Box>
                        )}
                        <Typography variant="body2" align="center" sx={{ mt: 2 }}>
                            <Link to="/login" style={{ textDecoration: 'none', color: '#6a11cb' }}>
                                Back to Login
                            </Link>
                        </Typography>
                    </CardContent>
                </Card>
            </Container>
        </Box>
    );
};

export default ForgotPasswordPage;